import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBuilding, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { RouterLink } from "vue-router";
import { useUserStore } from "@/stores/userStore";
import { getFullAppUrl } from "@/utils/utils";
import Heading from "@/components/Common/Heading.vue";
import CopyToClipboard from "@/components/CopyToClipboard.vue";
import License from "@/components/License/License.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
import UtcDate from "@/components/UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowInformation',
    props: {
        workflowInfo: null,
        embedded: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        library.add(faBuilding, faUser);
        const userStore = useUserStore();
        const gravatarSource = computed(() => { var _a; return `https://secure.gravatar.com/avatar/${(_a = props.workflowInfo) === null || _a === void 0 ? void 0 : _a.email_hash}?d=identicon`; });
        const publishedByUser = computed(() => { var _a; return `/workflows/list_published?owner=${(_a = props.workflowInfo) === null || _a === void 0 ? void 0 : _a.owner}`; });
        const relativeLink = computed(() => {
            return `/published/workflow?id=${props.workflowInfo.id}`;
        });
        const fullLink = computed(() => {
            return getFullAppUrl(relativeLink.value.substring(1));
        });
        const userOwned = computed(() => {
            if (userStore.currentUser) {
                return userStore.currentUser.username === props.workflowInfo.owner;
            }
            else {
                return false;
            }
        });
        return { __sfc: true, props, userStore, gravatarSource, publishedByUser, relativeLink, fullLink, userOwned, FontAwesomeIcon, RouterLink, Heading, CopyToClipboard, License, StatelessTags, UtcDate };
    }
});
